'use client';

import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';
import PortfolioProjectGallery from './PortfolioProjectGallery';

/** Marketing interior nav height — keep in sync with nav bar. */
const PORTFOLIO_NAV_HEIGHT = { xs: '4.5rem', md: '5.25rem' };

export default function PortfolioDetailPage({ portfolio }) {
  return (
    <Box
      component="section"
      className="portfolio-gallery-stage"
      sx={{
        '--portfolio-nav-height': PORTFOLIO_NAV_HEIGHT,
        '--portfolio-stage-py': { xs: '1.25rem', md: '1.5rem' },
      }}
    >
      <Container maxWidth="lg" className="portfolio-gallery-stage__container">
        <PortfolioProjectGallery images={portfolio.gallery} />
      </Container>
    </Box>
  );
}

PortfolioDetailPage.propTypes = {
  portfolio: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    gallery: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.shape({
          src: PropTypes.string.isRequired,
          alt: PropTypes.string,
          photographerCredit: PropTypes.string,
        }),
      ]),
    ).isRequired,
    parentCollection: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
